import React from 'react';
import { Video } from 'lucide-react';
import TeamLoginPortal from '@/components/TeamLoginPortal';

const StudioLogin = () => (
  <TeamLoginPortal
    system="studio"
    title="The Studio"
    subtitle="Sign in to book rooms, sign out gear, manage your team."
    icon={Video}
    accent="violet"
    membershipCheckUrl="/studio/team/me"
    defaultLanding="/studio"
  />
);

export default StudioLogin;
